import { MdOutlineMonetizationOn } from "react-icons/md";
import leadsService from "services/admin/leadsService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import KpiCard from "./KpiCard";

// Бэкенд отдаёт количество сделок по этапам воронки — суммируем.
const sumStages = (stages) => (stages ? Object.values(stages).reduce((acc, s) => acc + Number(s?.count || 0), 0) : 0);

const LeadsCount = ({ month }) => {
  const q = useDashboardQuery(["leads-count", month], async () => (await leadsService.getLeadsCount({ month })).data?.data);

  return (
    <KpiCard
      icon={MdOutlineMonetizationOn}
      accent="violet"
      label="Сделки"
      hint="Сделки на всех этапах воронки за выбранный период"
      to="/admin/leads"
      value={formatNumber(sumStages(q.data))}
      loading={q.isLoading}
      fetching={q.isPlaceholderData}
      error={q.error}
      onRetry={q.refetch}
    />
  );
};

export default LeadsCount;
